export default {
  watch: {
    myValue() {
      this.updateValue();
    },
    fieldValue() {
      this.setInitialValue();
    },
  },
  mounted() {
    this.setInitialValue();
  },
  methods: {
    updateValue() {
      this.$emit("updateValue", { field: this.fieldName, value: this.myValue });
    },
    setInitialValue() {
      this.myValue = this.fieldValue;
    },
  },
};
